var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRivalSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.76 56.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f7f7f7;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #d1f434;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.45,7.48h24.27c.64,0,1.15-.52,1.15-1.15v-2.84l9.67,7.39-9.67,7.39v-2.84c0-.64-.52-1.15-1.15-1.15h-7.98c-.64,0-1.15.52-1.15,1.15s.52,1.15,1.15,1.15h6.83v4.02c0,.44.25.84.64,1.03.16.08.34.12.51.12.25,0,.5-.08.7-.24l12.72-9.73c.28-.22.45-.56.45-.92s-.17-.7-.45-.92L30.42.24c-.35-.27-.82-.31-1.21-.12-.39.19-.64.59-.64,1.03v4.02H5.45c-.64,0-1.15.52-1.15,1.15s.52,1.15,1.15,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.12,35.31c-.35-.27-.82-.31-1.21-.12-.39.19-.64.59-.64,1.03v4.02H1.15c-.64,0-1.15.52-1.15,1.15s.52,1.15,1.15,1.15h24.27c.64,0,1.15-.52,1.15-1.15v-2.84l9.67,7.39-9.67,7.39v-2.84c0-.64-.52-1.15-1.15-1.15h-7.98c-.64,0-1.15.52-1.15,1.15s.52,1.15,1.15,1.15h6.83v4.02c0,.44.25.84.64,1.03.16.08.34.12.51.12.25,0,.5-.08.7-.24l12.72-9.73c.28-.22.45-.56.45-.92s-.17-.7-.45-.92l-12.72-9.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.31,29.95l-12.72-9.72c-.35-.27-.82-.31-1.21-.12-.39.19-.64.59-.64,1.03v4.02h-23.11c-.64,0-1.15.52-1.15,1.15s.52,1.15,1.15,1.15h24.27c.64,0,1.15-.52,1.15-1.15v-2.84l9.67,7.39-9.67,7.39v-2.84c0-.64-.52-1.15-1.15-1.15h-7.98c-.64,0-1.15.52-1.15,1.15s.52,1.15,1.15,1.15h6.83v4.02c0,.44.25.84.64,1.03.16.08.34.12.51.12.25,0,.5-.08.7-.24l12.72-9.73c.28-.22.45-.56.45-.92s-.17-.7-.45-.92Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRivalSendIcon);
export default __webpack_public_path__ + "static/media/rival-send-icon.ddfca781413f511bdaec13737e783999.svg";
export { ForwardRef as ReactComponent };